var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiomass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3791_7555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF8533"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21.3333C14 20.9651 14.2985 20.6666 14.6667 20.6666H21.3333C21.7015 20.6666 22 20.9651 22 21.3333C22 21.7015 21.7015 22 21.3333 22H14.6667C14.2985 22 14 21.7015 14 21.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0142 14.0978C19.3284 14.2898 19.4274 14.7001 19.2354 15.0143C18.9604 15.4644 18.8908 15.931 18.9168 16.4533C18.9301 16.7197 18.9678 16.9931 19.0144 17.2865C19.0256 17.3566 19.0374 17.429 19.0496 17.5029C19.0863 17.7267 19.1252 17.9644 19.1533 18.194C19.2287 18.8104 19.2494 19.5221 18.922 20.2119C18.5884 20.9145 17.9497 21.4824 16.9425 21.9402C16.6073 22.0926 16.212 21.9444 16.0597 21.6092C15.9073 21.274 16.0555 20.8788 16.3907 20.7264C17.2168 20.3509 17.5614 19.9688 17.7175 19.6401C17.8796 19.2986 17.8961 18.8979 17.8298 18.3559C17.8054 18.1557 17.7728 17.9571 17.7374 17.7413C17.7245 17.6621 17.7111 17.5807 17.6976 17.496C17.6493 17.1918 17.6021 16.8605 17.5851 16.5196C17.5507 15.8273 17.6395 15.0689 18.0977 14.319C18.2897 14.0048 18.7 13.9058 19.0142 14.0978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5778 14.2855C13.9832 15.2094 14.4913 15.7005 14.9648 15.9372C14.9708 15.9402 14.9768 15.9433 14.9827 15.9465C15.4959 16.2229 16.1001 16.3058 16.9518 16.2069C16.6776 15.5882 16.3481 15.1019 15.9412 14.806C15.4797 14.4704 14.7972 14.1898 13.5778 14.2855ZM12.5495 13.0772C14.5498 12.72 15.8121 13.0634 16.7255 13.7277C17.6348 14.3891 18.156 15.4933 18.4991 16.5227C18.5596 16.7041 18.5393 16.9027 18.4433 17.0681C18.3473 17.2335 18.1849 17.3497 17.9974 17.3872C16.6219 17.6623 15.4324 17.6993 14.3595 17.1252C13.3512 16.6173 12.529 15.5709 12.0289 13.9276C11.9734 13.7453 11.9986 13.548 12.0981 13.3854C12.1976 13.2229 12.3619 13.1107 12.5495 13.0772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1396 10.1968C23.2708 10.3288 23.3408 10.5097 23.3327 10.6956C23.2607 12.3527 22.8166 13.3929 22.0048 14.2047C21.9874 14.2221 21.969 14.2385 21.9498 14.2539C21.1458 14.8972 20.066 15.2606 18.7017 15.3324C18.5228 15.3418 18.3477 15.2789 18.2157 15.1577C18.0838 15.0365 18.0062 14.8674 18.0004 14.6883C17.9654 13.6111 18.2576 12.5485 18.8385 11.6407C18.8581 11.6101 18.8802 11.5811 18.9045 11.554C19.2485 11.1718 19.6845 10.7928 20.3009 10.5045C20.9137 10.2178 21.6714 10.0364 22.642 10.0005C22.828 9.99357 23.0084 10.0647 23.1396 10.1968ZM19.9325 12.4055C19.6442 12.8699 19.4554 13.3863 19.3751 13.9223C20.1291 13.7974 20.6824 13.5511 21.0882 13.2354C21.492 12.8226 21.793 12.299 21.9293 11.4033C21.4884 11.4721 21.1433 11.5824 20.8658 11.7122C20.4688 11.8979 20.1802 12.1374 19.9325 12.4055Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3791_7555",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3791_7555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3791_7555",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiomass);
export default __webpack_public_path__ + "static/media/biomass.60adb10f0bc75f48c3917099e3c0f8e9.svg";
export { ForwardRef as ReactComponent };